import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

//Firebase Operator Dashboard
const firebaseConfig = {
    apiKey: "AIzaSyCXuqfR1_QF8ftwk6H4mbXZbSihr4llwUg",
    authDomain: "operator-dashboard-4ef23.firebaseapp.com",
    projectId: "operator-dashboard-4ef23",
    storageBucket: "operator-dashboard-4ef23.firebasestorage.app",
    messagingSenderId: "699630287610",
    appId: "1:699630287610:web:007366958ca888bc00e743",
    measurementId: "G-N4B1JDKGYP"
};

const operatorDashboard = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(operatorDashboard);

// Set persistence to LOCAL (persists across browser sessions and tabs)
setPersistence(auth, browserLocalPersistence)
    .then(() => {
    })
    .catch((error) => {
        console.error("Error setting Firebase auth persistence:", error);
    });

export {
    operatorDashboard as userManagementApp,
    auth as userManagementAuth
};